import React from 'react';
import { observer, inject } from 'mobx-react';

import { Center, CenterParams } from './Center';
import { Ehr } from '@patient/store/ehr/Ehr';
import { ViewPortState } from '@store/ViewPort';
import { AuthUser } from '@store/AuthUser/AuthUser';
import { Locale } from 'chaika-enums';
import { AppState } from '@store/App/App';

interface Props extends CenterParams {}

interface StoreProps {
    app: AppState;
    ehr: Ehr;
    viewPort: ViewPortState;
    authUser: AuthUser;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const { ehr, viewPort } = this.props;

        const isMobile = viewPort.isMobileSize;
        const fullName = this.createFullNameString();

        return React.createElement(Center, {
            isMobile,
            fullName,
            recordId: ehr.recordId,
            birthDate: ehr.birthDate ?? '',
            age: ehr.ageString,
            phone: ehr.phone ?? '',
        });
    }

    private createFullNameString(): string {
        const {
            ehr,
            viewPort,
            authUser: { selectedLanguage },
        } = this.props;

        let fullName = '';

        if (viewPort.isMobileSize) {
            fullName = selectedLanguage
                ? selectedLanguage === Locale.En
                    ? ehr.engShortFullName
                    : ehr.getShortFullNameByTranslation(selectedLanguage)
                : ehr.shortFullName;
        } else {
            fullName = selectedLanguage
                ? selectedLanguage === Locale.En
                    ? ehr.engFullName
                    : ehr.getFullNameByLang(selectedLanguage)
                : ehr.fullName;
        }

        return fullName;
    }
}

export const CenterContainer = inject<Props, StoreProps>(
    Ehr.Name,
    ViewPortState.Name,
    AuthUser.Name,
    AppState.Name,
)(Component);
